import FormatCurrency from 'components/Common/FormatCurrency'
import { useFlightMemberPrice } from 'hooks/Flights/useFlightMemberPrice'
import LuxPlusLogoWrapper from 'luxPlus/components/LuxPlusLogoWrapper'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'

const CompactPrice = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${rem(4)};
  white-space: nowrap;
`

interface Props {
  flightDeal: Pick<App.FlightDeal, 'perAdultPrice' | 'luxPlusPerAdultPrice'>
  compact?: boolean
}

function FlightDealInlinePrice({ flightDeal, compact = false }: Props) {
  const intl = useIntl()
  const memberPrice = useFlightMemberPrice(flightDeal.perAdultPrice, flightDeal.luxPlusPerAdultPrice)
  if (memberPrice === undefined) {
    return <FormatCurrency value={flightDeal.perAdultPrice} format="roundedDollar" />
  }
  if (compact) {
    return <CompactPrice>
      <FormatCurrency value={memberPrice} format="roundedDollar" />
      <LuxPlusLogoWrapper height={10} />
    </CompactPrice>
  }
  return <span>
    {intl.formatMessage({
      id: 'yAF3QL_RO8DFvHSEPfoq',
      defaultMessage: '{memberPrice} with {logo} (Non-member {standardPrice}, save {saving})',
      description: 'Inline flight deal promotional price showing the LuxPlus price, non-member price and saving on deal pages and hotel flight banners',
    }, {
      memberPrice: <FormatCurrency value={memberPrice} format="roundedDollar" />,
      logo: <LuxPlusLogoWrapper height={10} />,
      standardPrice: <FormatCurrency value={flightDeal.perAdultPrice} format="roundedDollar" />,
      saving: <FormatCurrency value={flightDeal.perAdultPrice - memberPrice} format="roundedDollar" />,
    })}
  </span>
}

export default FlightDealInlinePrice
